import { render, staticRenderFns } from "./PONumber.vue?vue&type=template&id=676f289e&scoped=true"
import script from "./PONumber.vue?vue&type=script&lang=js"
export * from "./PONumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f289e",
  null
  
)

export default component.exports